import { cardsData } from '@/mocks/gossipData';

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            精选瓜文
          </h2>
          <p className="text-foreground-500 text-base">编辑精选 · 深度好瓜</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.map((item, i) => (
            <article
              key={i}
              className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-default flex flex-col"
            >
              <div className="relative w-full aspect-[16/9] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center px-2.5 py-1 rounded-full bg-primary-500/90 text-white text-xs font-medium whitespace-nowrap backdrop-blur-sm">
                    {item.category}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex-1 flex flex-col">
                <h3 className="text-sm md:text-base font-heading text-foreground-900 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3 flex-1">
                  {item.excerpt}
                </p>
                <div className="flex items-center justify-between mt-4 pt-3 border-t border-background-200/70">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    <i className="ri-time-line mr-1"></i>
                    {item.time}
                  </span>
                  <span className="text-xs text-primary-500 font-medium whitespace-nowrap cursor-default">
                    阅读全文 <i className="ri-arrow-right-line ml-0.5"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}